import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CustomInstructionsSidebar = ({ tabs, activeTab, onTabChange, }) => {
    return (_jsx("div", { className: "flex flex-col gap-1 py-[5.5px] w-[180px] shrink-0 bg-gray-100 border-r border-gray-300 overflow-y-auto", children: tabs.map((tab) => (_jsxs("button", { onClick: () => onTabChange(tab.id), className: `
            relative flex items-center px-3 py-[11px] text-left 
            text-[15px] transition-all duration-150 
            font-sans leading-[150%]
            cursor-pointer
            ${activeTab === tab.id
                ? "text-primary-purple-70 bg-transparent font-bold"
                : "text-gray-600 bg-transparent font-normal hover:bg-gray-200"}
          `, type: "button", children: [activeTab === tab.id && (_jsx("div", { className: "absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-[45px] bg-primary-purple-70" })), tab.label] }, tab.id))) }));
};
export default CustomInstructionsSidebar;
